import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import { match, P } from 'ts-pattern';
import CheckboxField from '../../../formFields/checkboxField';
import CheckboxButtonField from '../../../formFields/checkboxButtonField';
import StandardFieldLabel from '../../../formFields/formFieldWrapper/standardFieldLabel';
import { useBreakpoints } from '../../../../hooks';
import Chip from '../../chip';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const toSnakeCase = (input) => {
    if (typeof input === 'string')
        return _.snakeCase(input);
    if (Array.isArray(input))
        return _.snakeCase(input.join(' '));
    return 'none';
};
const isSubset = (a, b) => {
    return _.difference(b, a).length === 0;
};
const MultiSelect = ({ definition, value, elmId, onChange, }) => {
    const breakpoint = useBreakpoints();
    const isMobile = breakpoint === 'mobile';
    const [selectedValues, setSelectedValues] = useState(_.isNil(value) ? [] : value);
    useEffect(() => {
        setSelectedValues(_.isNil(value) ? [] : value);
    }, [value]);
    const onChangeSelection = (e, definition, value, checked) => {
        let newValues = [];
        if (Array.isArray(value)) {
            const currentValues = selectedValues;
            if (checked) {
                newValues = _.uniq([...(currentValues || []), ...value]);
            }
            else {
                newValues = currentValues.filter(v => !value.includes(v));
            }
        }
        else if (typeof value === 'string') {
            if (checked) {
                newValues = _.uniq([...(selectedValues || []), value]);
            }
            else {
                if (selectedValues?.length) {
                    newValues = selectedValues.filter(v => v !== value);
                }
                else {
                    newValues = selectedValues;
                }
            }
        }
        setSelectedValues(newValues);
        onChange(definition.name, newValues);
        e?.currentTarget.querySelector('input')?.focus();
    };
    const contains = (value, optionValue) => {
        return (match(definition.controlValueType)
            .with(P.when(v => v === 'string[]' &&
            Array.isArray(value) &&
            Array.isArray(optionValue)), () => isSubset(value, optionValue))
            .otherwise(() => {
            if (Array.isArray(value))
                return value.includes(optionValue);
            return false;
        }));
    };
    const isChip = definition.mode === 'chip';
    const isCheckboxButton = definition.mode === 'checkboxButton';
    const CheckboxComp = isCheckboxButton ? CheckboxButtonField : CheckboxField;
    return (_jsx(Form, { className: cx('multi-select-container', {
            'checkbox-button': isCheckboxButton || isChip,
            'two-columns': !!definition.styleIntent?.twoColumns,
            'left-justified': isChip,
        }), children: definition.options.map((option, index) => isChip ? (_jsx(Chip, { content: option.label, elmId: `${elmId}_${definition.name}`, onClick: (e) => onChangeSelection(e, definition, [option.value], !value?.find(v => v === option.value)), selectionStyle: 'light', type: 'filter', isSelected: !!value?.find(v => v === option.value) }, index)) : (_jsx(CheckboxComp, { compact: isMobile, elmId: `${elmId}_${toSnakeCase(option.value)}`, value: option.value || '', checked: contains(value, option.value), onChange: (e, data) => {
                onChangeSelection(e, definition, data.value, data.checked);
            }, valueAsArray: definition.controlValueType === 'string[]', ...(isCheckboxButton
                ? {
                    fluid: true,
                    iconName: option.icon,
                    label: option.label,
                    layoutDirection: 'vertical',
                }
                : {
                    helpContent: option.tooltip,
                    role: 'info',
                    tabIndex: index,
                    label: (_jsx(StandardFieldLabel, { elmId: `${elmId}_${toSnakeCase(option.value)}_label`, label: option.label, subLabel: option.description || '' })),
                }) }, index))) }));
};
export default MultiSelect;
//# sourceMappingURL=multiSelect.js.map